import { render, staticRenderFns } from "./AmazonPayWidget.vue?vue&type=template&id=5a5262fc&scoped=true&lang=pug&"
import script from "./AmazonPayWidget.vue?vue&type=script&lang=js&"
export * from "./AmazonPayWidget.vue?vue&type=script&lang=js&"
import style0 from "./AmazonPayWidget.vue?vue&type=style&index=0&id=5a5262fc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5262fc",
  null
  
)

export default component.exports